module.exports = __webpack_public_path__ + "img/Conversational form_bg.549851ee.gif";